import ApiUrls from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";
import moment from "moment";

const insertRegions = (fields) => {
  var data = {
    regionName: fields.regionName,
  };
  return ApiHelper.postRequest(ApiUrls.INSERT_REGIONS, data);
};

const getRegions = () => {
  return ApiHelper.getRequest(ApiUrls.GET_REGIONS);
};

export const RegionsService = {
  insertRegions,
  getRegions,
};
